// TODO: Should this constant be treated as "local" and be moved to the component that uses it?
// TODO: Should this constant be rename to `TEAM_MAP_TYPE`?
const MAP_TYPE = {
    QUALIFIED_ADDRESSES: 'qualifiedAddresses',
    WEEKS_SINCE_KNOCKED: 'weeksSinceKnocked',
    PIN_SCORE: 'pinScore',
    NONE: 'none',
};
export default MAP_TYPE;
